module.exports = __webpack_public_path__ + "static/media/partTBG.424ab4e5.jpg";